import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sipp_warranty_blue_small",
  "use": "icon-sipp_warranty_blue_small-usage",
  "viewBox": "0 0 738.46 738.46",
  "content": "<symbol viewBox=\"0 0 738.46 738.46\" id=\"icon-sipp_warranty_blue_small\">\n  <defs>\n    <style>\n      #icon-sipp_warranty_blue_small .cls-1 {\n        fill: #273e95;\n        stroke-width: 0px;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M369.23,0c46.15,0,83.54,50.62,124.46,68s104.92,7.85,136,40.77,23.23,93.38,40.77,136,68,78.31,68,124.46-50.62,83.54-68,124.46-7.85,104.92-40.77,136-93.38,23.54-136,40.77-78.31,68-124.46,68-83.54-50.62-124.46-68-104.92-7.85-136-40.77-23.54-93.38-40.77-136S0,415.38,0,369.23s50.62-83.54,68-124.46,7.85-104.92,40.77-136,93.38-23.54,136-40.77S323.08,0,369.23,0ZM325.15,396.67l-63.4-56.79c-10.4-9.32-26.4-8.42-35.7,2l-23.39,26.23c-9.09,10.19-8.43,25.75,1.47,35.14l107.08,101.49c7.84,7.43,20.09,7.51,28.03.19l196.03-207.08c9.63-10.17,9.14-26.24-1.09-35.81l-29.02-27.13c-10.33-9.66-26.57-8.95-36.03,1.57l-143.99,160.19Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sipp_warranty_blue_small.svg
// module id = ceIW
// module chunks = 49